<template>
  <section class="main">
    <component
      :is="item.moduleCode"
      v-for="(item, index) in comData"
      :key="item.moduleCode + index"
      :homeData="homeData"
    />
  </section>
</template>
<script>
import { Menus, Banner, Category, Shop, Announce } from "./index";
export default {
  name: "moduleCom",
  props: {
    comData: {
      type: Array,
      default: () => [],
    },
	img:'',
    homeData: {
      type: Object,
    },
  },
  data() {
    return {
      componentType: "menus", // 这里是你的数据字段，根据不同的数据值来决定渲染哪个组件
    };
  },
  computed: {
    componentName() {
      switch (this.componentType) {
        case "menus":
          return "Menus";
        case "banner":
          return "Banner";
        case "category":
          return "Category";
        case "announce":
          return "Announce";
        case "shop":
          return "Shop";
        default:
          return "Menu";
      }
    },
  },
  components: {
    Menus,
    Banner,
    Category,
    Shop,
    Announce,
  },
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
